module.exports = ".graph-space{\r\n    width: 840px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0114-result-analysis/a0114-result-analysis.component.css
// module id = ./src/app/a0114-result-analysis/a0114-result-analysis.component.css
// module chunks = main